export { IconPrimaryAdministrator } from './IconPrimaryAdministrator';
